module.exports = __webpack_public_path__ + "img/video-off.4bff58bd.svg";